export default "__VITE_ASSET__C_4J_D93__"